// assets/edm-bundle-utils.js
// Pure Helper-Funktionen (keine Abhängigkeiten zu anderen Modulen)

window.EdumonBundle = window.EdumonBundle || {};

window.EdumonBundle.Utils = {
  /**
   * Safe JSON parsing with fallback
   * @param {string} s - JSON string to parse
   * @param {*} fb - Fallback value if parsing fails
   * @returns {*} Parsed value or fallback
   */
  safeParseJSON: function(s, fb) {
    try {
      return JSON.parse(s);
    } catch(e) {
      return fb;
    }
  },
  
  /**
   * Format money (cents to formatted string)
   * @param {number} cents - Price in cents
   * @param {string} format - Format string (default: '{{ amount }}')
   * @returns {string} Formatted price string
   */
  fmtMoney: function(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try {
        return Shopify.formatMoney(cents, format || '{{ amount }}');
      } catch(e) {}
    }
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return (format || '€{{amount}}').replace(/\{\{\s*amount\s*\}\}/, value);
  },
  
  /**
   * Converts Shopify CDN image URLs to optimized thumbnail sizes
   * Context7: Performance Optimization - Reduces bandwidth for slot images (LCP improvement)
   * 
   * @param {string} url - Original image URL
   * @param {string} size - Target size (e.g., '160x160_crop_center')
   * @returns {string} Optimized URL or original if not Shopify CDN
   */
  getThumbSrc: function(url, size = '160x160_crop_center') {
    if (!url || typeof url !== 'string') return url || '';
    
    // Check if it's a Shopify CDN URL
    if (!url.includes('cdn.shopify.com')) return url;
    
    // Shopify CDN pattern: filename_SIZE.ext or filename_SIZE.ext?v=...
    // Common sizes: _800x, _1024x1024, _master, _grande, _large, etc.
    
    // Pattern 1: Replace existing size suffix (e.g., _800x, _1024x1024, _master)
    // Matches: _SIZE before file extension, optionally followed by query string
    const sizeSuffixPattern = /_(\d+x\d+|master|grande|large|medium|compact|small|thumb|icon|pico)(?=\.(jpg|jpeg|png|webp|gif|avif)(\?|$|#))/i;
    
    if (sizeSuffixPattern.test(url)) {
      return url.replace(sizeSuffixPattern, `_${size}`);
    }
    
    // Pattern 2: Insert size before file extension if no size suffix exists
    const extPattern = /\.(jpg|jpeg|png|webp|gif|avif)(\?|$|#)/i;
    const extMatch = url.match(extPattern);
    if (extMatch) {
      const ext = extMatch[0];
      return url.replace(ext, `_${size}${ext}`);
    }
    
    // Fallback: return original URL if pattern matching fails
    return url;
  },
  
  /**
   * Normalisiert Bild-URLs aus verschiedenen Shopify-Datenquellen
   * Unterstützt: Liquid JSON, Ajax API, verschiedene Objekt-Strukturen
   * 
   * @param {Object} variant - Variant object
   * @param {Object} product - Product object (optional)
   * @returns {string} Normalized image URL
   */
  normalizeImageUrl: function(variant, product = null) {
    let imgSrc = '';
    
    // PRIORITY 1: Variant.featured_media (wie in Liquid) - Shopify API Format
    // Context7: Konsistenz mit Liquid-Template (edm-bundle-builder-sheet-panel.liquid Zeile 71)
    if (variant.featured_media) {
      if (typeof variant.featured_media === 'string') {
        imgSrc = variant.featured_media;
      } else if (variant.featured_media.src) {
        imgSrc = variant.featured_media.src;
      } else if (variant.featured_media.url) {
        imgSrc = variant.featured_media.url;
      } else if (variant.featured_media.preview) {
        // Shopify Media Object Format (Ajax API)
        imgSrc = variant.featured_media.preview.image?.url || variant.featured_media.preview.image?.src || '';
      }
    }
    
    // PRIORITY 2: Variant.image (String) - Liquid JSON Format
    if (!imgSrc && variant.image) {
      if (typeof variant.image === 'string') {
        imgSrc = variant.image;
      } else if (variant.image.src) {
        imgSrc = variant.image.src;
      } else if (variant.image.url) {
        imgSrc = variant.image.url;
      }
    }
    
    // PRIORITY 3: Variant.featured_image (Objekt) - Ajax API Format
    if (!imgSrc && variant.featured_image) {
      if (typeof variant.featured_image === 'string') {
        imgSrc = variant.featured_image;
      } else if (variant.featured_image.src) {
        imgSrc = variant.featured_image.src;
      } else if (variant.featured_image.url) {
        imgSrc = variant.featured_image.url;
      }
    }
    
    // PRIORITY 3: Product.featured_image (Fallback) - Ajax API Format
    if (!imgSrc && product) {
      if (product.featured_image) {
        if (typeof product.featured_image === 'string') {
          imgSrc = product.featured_image;
        } else if (product.featured_image.src) {
          imgSrc = product.featured_image.src;
        } else if (product.featured_image.url) {
          imgSrc = product.featured_image.url;
        }
      }
    }
    
    // PRIORITY 4: Product.image (Fallback) - Alternative Ajax API Format
    if (!imgSrc && product && product.image) {
      if (typeof product.image === 'string') {
        imgSrc = product.image;
      }
    }
    
    // HTTPS-Erzwingung und Protokoll-Normalisierung
    if (imgSrc) {
      // HTTP zu HTTPS
      if (imgSrc.startsWith('http:')) {
        imgSrc = imgSrc.replace('http:', 'https:');
      }
      // Protocol-relative zu HTTPS
      if (imgSrc.startsWith('//')) {
        imgSrc = 'https:' + imgSrc;
      }
    }
    
    // PRIORITY 5: Placeholder (wenn alles fehlschlägt)
    if (!imgSrc) {
      imgSrc = window.EdumonBundle?.Config?.DEFAULTS?.PLACEHOLDER_IMAGE || 'https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';
      console.warn('[Bundle Builder] No image found for variant, using placeholder', {
        variantId: variant.id,
        variantTitle: variant.title,
        hasVariantImage: !!variant.image,
        hasVariantFeaturedImage: !!variant.featured_image,
        hasProductImage: product ? !!product.featured_image : false
      });
    }
    
    return imgSrc;
  },
  
  /**
   * Promise-basiertes Delay
   * @param {number} ms - Milliseconds to delay
   * @returns {Promise} Promise that resolves after delay
   */
  bbDelay: function(ms) {
    return new Promise(r => setTimeout(r, ms));
  },
  
  /**
   * DOM Ready Helper
   * @param {Function} fn - Function to execute when DOM is ready
   */
  onReady: function(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  },
  
  /**
   * Mobile Detection Helper
   * @returns {boolean} True if mobile viewport
   */
  isMobile: function() {
    const breakpoint = window.EdumonBundle?.Config?.CONSTANTS?.MOBILE_BREAKPOINT || 989;
    return window.matchMedia(`(max-width: ${breakpoint}px)`).matches;
  },
  
  /**
   * Get Mobile Media Query Object
   * @returns {MediaQueryList} MediaQueryList object
   */
  getMobileMQ: function() {
    const breakpoint = window.EdumonBundle?.Config?.CONSTANTS?.MOBILE_BREAKPOINT || 989;
    return window.matchMedia(`(max-width: ${breakpoint}px)`);
  },
  
  /**
   * Debounce Helper
   * @param {Function} fn - Function to debounce
   * @param {number} ms - Delay in milliseconds
   * @returns {Function} Debounced function
   */
  debounce: function(fn, ms) {
    let timeoutId;
    return function(...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn.apply(this, args), ms);
    };
  },
  
  /**
   * Cap items to maximum slots
   * Context7: Single Source of Truth - Centralized maximum capping logic
   * 
   * @param {Object} items - Items object {variantId: qty}
   * @param {number} maxSlots - Maximum slots
   * @returns {Object} Capped items object
   */
  capToMaximum: function(items, maxSlots) {
    const totalQty = Object.values(items).reduce((a, b) => a + b, 0);
    if (totalQty <= maxSlots) return items;
    
    console.warn('[Bundle Builder] Capping items to maximum:', maxSlots);
    let remaining = maxSlots;
    const capped = {};
    
    // Priority: Keep existing items proportionally
    for (const [vid, qty] of Object.entries(items)) {
      if (remaining <= 0) break;
      const cappedQty = Math.min(qty, remaining);
      capped[vid] = cappedQty;
      remaining -= cappedQty;
    }
    
    return capped;
  },
  
  /**
   * Find Add to Cart button
   * @param {Element} root - Root element to search in (default: document)
   * @returns {Element|null} ATC button element or null
   */
  findATC: function(root) {
    const scope = root || document;
    const forms = Array.from(scope.querySelectorAll('form[action^="/cart/add"]'));
    for (const f of forms) {
      const btn = f.querySelector('button[name="add"], [type="submit"]');
      if (btn) return btn;
    }
    return null;
  },
  
  /**
   * Compute document top position for element
   * @param {Element} el - Element
   * @returns {number} Document top position
   */
  computeDocTop: function(el) {
    const r = el.getBoundingClientRect();
    const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    return r.top + scrollY;
  }
};

